import React from 'react'
import Grid from '@mui/material/Grid'
import styles from './Body-students-employees.module.css'

import Card from '@mui/material/Card'
import CardActionArea from '@mui/material/CardActionArea';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Grow from '@mui/material/Grow';

import MFApdf from '../../../../assets/pdf/Microsoft-Authenticator-Guide.pdf';

const employeeSection = {
    // 'COVID-19 Symptom Questionnaire': {
    //   href: 'https://blogs.molloy.edu/covid-19-questionnaire',
    //   img: require('../../../../assets/students-and-employees/covid_questionnaire.png'),
    //   p: "This form must be filled out before each visit to Molloy's campuses."
    // },
    'Molloy University: Policies': {
      href: 'https://policylibrary.molloy.edu/policies',
      img: require('../../../../assets/students-and-employees/policies.png'),
      p: "."
    },
    'Strategic Plan 2028': {
      href: 'https://intranet.molloy.edu/strategic-plan',
      img: require('../../../../assets/students-and-employees/strategic-plan.png'),
      p: "."
    },
    'Human Resources Forms': {
      href: 'https://www.molloy.edu/about/administration/human-resources/forms-human-resources',
      img: require('../../../../assets/students-and-employees/hr-forms.png'),
      p: "."
    },
    'E-mail & Office 365': {
        href: 'https://m365.cloud.microsoft/apps',
        img: require('../../../../assets/students-and-employees/outlook.png'),
        p: "Employees at Molloy can access their email via Microsoft Office 365. Click here and login to access your '@molloy.edu' employee email account."
    },
    'Board Portal': {
      href: 'https://auth.onboardmeetings.com/',
      img: require('../../../../assets/students-and-employees/onboard.png'),
      p: "."
    },
    'Health Portal': {
      href: 'https://molloy.studenthealthportal.com/',
      img: require('../../../../assets/students-and-employees/health-heart-stethoscope.jpg'),
      p: "."
    },
    'Stellic': {
      href: 'https://stellic.molloy.edu',
      img: require('../../../../assets/students-and-employees/stellic.png'),
      p: '.'
    },
    "Scholarships": {
      href: 'https://scholarships.molloy.edu',
      img: require('../../../../assets/students-and-employees/scholarships.png'),
      p: "Molloy employees can access their scholarship admin account here to review scholarships."
    },
    "LinkedIn Learning": {
      href: 'https://www.linkedin.com/learning-login',
      img: require('../../../../assets/students-and-employees/linked-in-learning.png'),
      p: "Molloy employees and students can access their LinkedIn Learning profiles here"
    },

    // 'Accounting Forms': {
    //     href: 'https://www.molloy.edu/about/administration/accounts-payable/',
    //     img: require('../../../../assets/students-and-employees/accounting-forms.png'),
    //     p: "."
    // },
    'LogMeIn': {
      href: 'https://logmein.com',
      img: require('../../../../assets/students-and-employees/logmein.png'),
      p: ""
    },
    // 'GoToMyPC': {
    //   href: 'https://www.gotomypc.com/',
    //   img: require('../../../../assets/students-and-employees/gotomypc.png'),
    //   p: ""
    // },
    'Institutional Research Data Requests': {
      href: 'https://forms.office.com/Pages/ResponsePage.aspx?id=bSl5yj94AEmWHqscc8qGjqxd9CP44nBNnzHY3svIy9RUQTZPQUdMUEk0V1FHUEJVUFJQM1gwREE4NS4u',
      img: require('../../../../assets/students-and-employees/data_requests.png'),
      p: ""
    },
    'Zoom': {
      href: 'https://zoom.us/',
      img: require('../../../../assets/students-and-employees/zoom.png'),
    },
    'MFA Registration': {
        href: 'https://molloycollege.app.box.com/s/cds7cygk6yleah0jb4js4rr1mvl5uyt0',
        img: require('../../../../assets/students-and-employees/mfa.png'),
        p: "Employees can setup a Multi-Factor Authentication process for their email accounts. Click here for detailed instructions."
    },
    'Microsoft Authenticator Guide': {
        href: MFApdf,
        img: require('../../../../assets/students-and-employees/mfa-guide.png'),
        p: "Employees can view this guide for detailed answers on how to setup mfa."
    },
    'ADP Workforce Now': {
      href: 'https://workforcenow.adp.com',
      img: require('../../../../assets/students-and-employees/adp.png'),
      p: "n/a"
    },
    'Ad Astra': {
      href: 'https://www.aaiscloud.com/MolloyU',
      img: require('../../../../assets/students-and-employees/astra_logo.png'),
      p: "Employees can access Ad Astra here."
    },
    'IT & Facilities Support (Tickets)': {
        href: 'https://help.molloy.edu/',
        img: require('../../../../assets/students-and-employees/ticketing.png'),
        p: "Employees can login here to submit work orders and IT requests online."
    },
    'Canvas': {
        href: 'https://molloy.instructure.com',
        img: require('../../../../assets/students-and-employees/canvas.png'),
        p: "Course resources for Molloy employees can be found here on Canvas! Click here and login to access your Canvas profile."
    },
    'Engage Molloy - GivePulse': {
      href: 'https://molloy.givepulse.com',
      img: require('../../../../assets/students-and-employees/engage.png'),
      p: "."
    },
    'International Travel Notification Form: E-mail & Software Access Requests': {
      href: 'https://forms.cloud.microsoft/Pages/ResponsePage.aspx?id=bSl5yj94AEmWHqscc8qGjvFngLPaVftKtq6INs8lVi5UQTBNSERFV0NaMDBFRzhPRTNXMDJNRUJJMi4u',
      img: require('../../../../assets/students-and-employees/hr-forms.png'),
      p: "."
    },
    "Lions Den": {
        href: 'https://lionsden.molloy.edu',
        img: require('../../../../assets/students-and-employees/lionsden.png'),
        p: "Employees can login to Lions Den to access information related to their academics, finances, course registration, etc."
    }, 
    'Password Reset': {
        href: 'https://aka.ms/sspr',
        img: require('../../../../assets/students-and-employees/self_service.png'),
        p: "Unable to access your employee email? Click here and follow the prompts to reset your employee email password."
    },
    // 'Wi-Fi Instructions': {
    //   href: 'https://molloycollege.box.com/s/mji7o7gmk25tr11gu4u4ywxo740ukv34',
    //   img: require('../../../assets/students-and-employees/employee_wifi.png'),
    //   p: "How to add the Wi-Fi networks to your Windows 10 PC."
    // },
    // 'Mobile Wi-Fi Instructions': {
    //   href: 'https://molloycollege.box.com/s/2ml6era11csfxeu4hk29wzc7j322l0oi',
    //   img: require('../../../assets/students-and-employees/mobile_wifi.png'),
    //   p: "How to add your mobile phone to Molloy's WiFi"
    // },
    'Campus Labs': {
      href: 'https://molloy.campuslabs.com/home',
      img: require('../../../../assets/students-and-employees/campuslabs.png'),
      p: "Assessment Service for Faculty."
    },
    'ACCOMMODATE - Center for Access and Disability': {
      href: 'https://molloy-accommodate.symplicity.com/',
      img: require('../../../../assets/students-and-employees/mural.jpg'),
      p: "ACCOMMODATE Center for Access and Disability"
    },
    'TGI Portal': {
      href: 'https://www.mytgiportal.com/',
      img: require('../../../../assets/students-and-employees/tgi_portal.png'),
      p: "TGI Portal for employees."
    },
    'Amazon Purchasing Orders': {
      href: 'https://www.molloy.edu/about/administration/finance-department/purchasing/#accordion3',
      img: require('../../../../assets/students-and-employees/amazon-purchasing-orders.png'),
      p: "Amazon Purchasing Orders"
    },
    'University Marketing & Communications Support Requests': {
    href: 'https://portal.molloy.edu/marketing',
    img: require('../../../../assets/students-and-employees/creativerequest.png'),
    p: "Photography Request Form"
  },
}

const studentSection = {
  // 'COVID-19 Symptom Questionnaire': {
  //   href: 'https://blogs.molloy.edu/covid-19-questionnaire',
  //   img: require('../../../assets/students-and-employees/covid_questionnaire.png'),
  //   p: "This form must be filled out before each visit to Molloy's campuses."
  // },
  'Health Portal': {
    href: 'https://molloy.studenthealthportal.com/',
    img: require('../../../../assets/students-and-employees/health-heart-stethoscope.jpg'),
    p: "."
  },
  'Molloy Life': {
    href: 'https://life.molloy.edu/',
    img: require('../../../../assets/students-and-employees/molloy-life.png'),
    p: "."
  },
  "Student Email": {
    href: 'https://accounts.google.com',
    img: require('../../../../assets/students-and-employees/gmail_logo.png'),
    p: "Molloy students can access their email via Google's Gmail. Click here and login to access your '@lions.molloy.edu' student email account."
  },
  "Scholarships": {
    href: 'https://scholarships.molloy.edu',
    img: require('../../../../assets/students-and-employees/scholarships.png'),
    p: "Molloy students can access their scholarships here."
  },
  "Report Wi-Fi Problem": {
    href: 'https://www.molloy.edu/about/administration/office-for-university-technology-services/technology-support-services/wifi-issues',
    img: require('../../../../assets/students-and-employees/wifi-problem.png'),
    p: "Molloy students can report wifi issues here."
  },
  "Office 365": {
    href: 'https://www.office.com',
    img: require('../../../../assets/students-and-employees/outlook.png'),
    p: ''
  },
  'Canvas': {
    href: 'https://molloy.instructure.com',
    img: require('../../../../assets/students-and-employees/canvas.png'),
    p: "Course resources for Molloy students can be found here on Canvas! Click here and login to access your Canvas profile."
  },
  "Lions Den": {
      href: 'https://lionsden.molloy.edu',
      img: require('../../../../assets/students-and-employees/lionsden.png'),
      p: "Students can click here and login to access their student information related to their academics, finances, course registration, etc."
  },   
  'Password Reset': {
    href: 'https://selfservice.molloy.edu',
    img: require('../../../../assets/students-and-employees/self_service.png'),
    p: "Unable to access your student email? Click here and follow the prompts to reset your student email password."
  },
  'Engage Molloy - GivePulse': {
    href: 'https://molloy.givepulse.com',
    img: require('../../../../assets/students-and-employees/engage.png'),
    p: "."
  },
  'Stellic': {
      href: 'https://stellic.molloy.edu',
      img: require('../../../../assets/students-and-employees/stellic.png'),
      p: '.'
    },
  'JET Library': {
      href: 'https://www.molloy.edu/academics/resources/library/',
      img: require('../../../../assets/students-and-employees/library.png'),
      p: '.'
    },
  "LinkedIn Learning": {
      href: 'https://www.linkedin.com/learning-login',
      img: require('../../../../assets/students-and-employees/linked-in-learning.png'),
      p: "Molloy employees and students can access their LinkedIn Learning profiles here"
    },
  // 'IT Support': {
  //       href: 'https://help.molloy.edu/',
  //       img: require('../../../assets/students-and-employees/ticketing.png'),
  //       p: "Students can login here to submit work orders and IT requests online."
  //   },
  // 'Stay Safe Pledge': {
  //   href: 'https://blogs.molloy.edu/stay-safe-pledge',
  //   img: require('../../../../assets/students-and-employees/stay_safe_pledge.png'),
  //   p: "All students must fill out this form once before entering campus."
  //  },
  // 'Wi-Fi Instructions': {
  //   href: 'https://molloycollege.box.com/s/ck43wpnh82ualol4qsoxuhe4n5kvqr3r',
  //   img: require('../../../../assets/students-and-employees/student_wifi.png'),
  //   p: "How to add the Wi-Fi networks to your Windows 10 PC."
  // },
  // 'Mobile Wi-Fi Instructions': {
  //   href: 'https://molloycollege.box.com/s/2ml6era11csfxeu4hk29wzc7j322l0oi',
  //   img: require('../../../../assets/students-and-employees/mobile_wifi.png'),
  //   p: "How to add your mobile phone to Molloy's WiFi"
  // },
  'ACCOMMODATE - Center for Access and Disability': {
    href: 'https://molloy-accommodate.symplicity.com/',
    img: require('../../../../assets/students-and-employees/mural.jpg'),
    p: "ACCOMMODATE Center for Access and Disability"
  },
  // 'Beacon': {
  //   href: 'https://molloy.campuslabs.com/beaconv2/',
  //   img: require('../../../../assets/students-and-employees/beacon.jpg'),
  //   p: "Beacon for Students"
  // },
  'Molloy Surveys': {
    href: 'https://blogs.molloy.edu/survey-login/',
    img: require('../../../../assets/students-and-employees/surveys.png'),
    p: "Students can login to submit their surveys here."
  },
  'Handshake': {
    href: 'https://app.joinhandshake.com',
    img: require('../../../../assets/students-and-employees/handshake.png'),
    p: "Handshake for students"
  },
  'Add Print Funds (only accessible on-campus)': {
    href: 'https://addprintfunds.molloy.edu',
    img: require('../../../../assets/students-and-employees/addprintfunds.png'),
    p: "Add Print Funds"
  }
}

const generateCards = (sectionObj) => {
  /*
    <p>
                                  {sectionObj[siteName].p}
                                </p>
  */
    return Object.keys(sectionObj).map((siteName) => {
        return (
        <Grid key={siteName} item xs={12} sm={12} md={12} lg={12} xl={12} className={styles.cardsContainer}>
            <Grow direction="up" in={true} timeout={{enter: 900, exit: 0}}>
                <Card className={styles.card} >
                    <CardActionArea target='_blank' rel='noopener noreferrer' href={sectionObj[siteName].href}>
                        <div className={styles.cardLayout}>
                            <CardMedia
                              component="img"
                              alt={siteName}
                              className={styles.media}
                              //height="220"
                              src={sectionObj[siteName].img}
                              title={siteName}
                              />
                              <div className={styles.cardContent}> 
                                <h4 className={styles.linkLabel}>{siteName}</h4>
                              </div>
                        </div>
                    </CardActionArea>
                </Card>
             </Grow>
        </Grid>
        )
    })
}

const Body = () => {
  return (
  <Grid container className={styles.bodyContainer}>
    <Grid item xs={12} sm={12} md={6}>
      <h1 style={{textAlign: "center"}}>Students</h1>
        <hr style={{width: '80%'}}/>
      <Grid container justify="center">
        {generateCards(studentSection)}
      </Grid>
    </Grid>
    <Grid item xs={12} sm={12} md={6}>
      <h1 style={{textAlign: "center"}}>Employees</h1>
        <hr  style={{width: '80%'}}/>
      <Grid container justify="center">
        {generateCards(employeeSection)}
      </Grid>
    </Grid>
  </Grid>
  )
}

export default Body